// extracted by mini-css-extract-plugin
export default {"description":"UxFS_","fullHeight":"pGCYO","header":"QZ_kd","editButton":"tpIS2","content":"KTJ6R","descriptionRow":"wC5uA","label":"Do4U0","loadingIndicator":"rmcVp"};